export const USER_ANALYTICS_TRACKER_UPDATE = 'USER_ANALYTICS_TRACKER_UPDATE';
export const USER_ANALYTICS_TRACKER_DELETE = 'USER_ANALYTICS_TRACKER_DELETE';
export const USER_ANALYTICS_SET = 'USER_ANALYTICS_SET';
